/**
 * FIDELITY-02 — homepage motion behaviour (canon: index-motion.html
 * ca-motion-js). Scroll reveals (IntersectionObserver, once, 60ms stagger
 * max 3 steps, threshold 0.15) + FAQ open/close height animation (300ms
 * height, answer fade 180/150ms). Canon bezier == --ease-standard.
 * Our markup is known (no canon-style runtime classification heuristics):
 * the group map below names our section selectors directly.
 * Scene 1 (quality production line) mounts in clickable-home-block.
 */
(function () {
  'use strict';

  var EASE = 'cubic-bezier(0.2, 0, 0, 1)'; /* == --ease-standard */
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* [groupSelector, itemSelector] — canon REVEAL_GROUPS mapped to our DOM */
  var GROUPS = [
    ['.clickable-make-tiles__row', ':scope > a'],
    ['.clickable-home-block__tiles', ':scope > a'],
    ['.clickable-featured__grid', ':scope > li'],
    ['.clickable-trust-strip__row', ':scope > div'],
    ['.clickable-reviews__cards', ':scope > div'],
    ['.clickable-faq', ':scope details'],
  ];

  function markItems() {
    GROUPS.forEach(function (pair) {
      document.querySelectorAll(pair[0]).forEach(function (group) {
        group.querySelectorAll(pair[1]).forEach(function (item) {
          item.setAttribute('data-mrv-item', '');
        });
      });
    });
  }

  function revealAll() {
    document.querySelectorAll('[data-mrv-item]').forEach(function (el) {
      el.setAttribute('data-rv', '');
    });
  }

  function setupReveal() {
    if (reduce || !('IntersectionObserver' in window)) { revealAll(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var items = entry.target.querySelectorAll('[data-mrv-item]');
        items.forEach(function (item, idx) {
          var delay = Math.min(idx, 3) * 60; /* canon :251 */
          setTimeout(function () { item.setAttribute('data-rv', ''); }, delay);
        });
      });
    }, { threshold: 0.15 });
    GROUPS.forEach(function (pair) {
      document.querySelectorAll(pair[0]).forEach(function (g) { io.observe(g); });
    });
  }

  /* FAQ height + fade (canon :296-339) */
  function onHeightEnd(el, cb) {
    function te(e) { if (e.propertyName !== 'height') return; el.removeEventListener('transitionend', te); cb(); }
    el.addEventListener('transitionend', te);
  }
  function openFaq(d, ans) {
    d.__anim = true;
    d.open = true;
    var pb = getComputedStyle(ans).paddingBottom;
    var full = ans.scrollHeight;
    ans.style.overflow = 'hidden'; ans.style.height = '0px';
    ans.style.paddingBottom = '0px'; ans.style.opacity = '0';
    void ans.offsetHeight;
    requestAnimationFrame(function () {
      ans.style.transition = 'height 300ms ' + EASE + ', padding-bottom 300ms ' + EASE + ', opacity 180ms 120ms ' + EASE;
      ans.style.height = full + 'px'; ans.style.paddingBottom = pb; ans.style.opacity = '1';
    });
    onHeightEnd(ans, function () {
      ans.style.transition = ''; ans.style.height = ''; ans.style.overflow = '';
      ans.style.paddingBottom = ''; ans.style.opacity = '';
      d.__anim = false;
    });
  }
  function closeFaq(d, ans) {
    d.__anim = true;
    var pb = getComputedStyle(ans).paddingBottom;
    var full = ans.scrollHeight;
    ans.style.overflow = 'hidden'; ans.style.height = full + 'px';
    ans.style.paddingBottom = pb; ans.style.opacity = '1';
    void ans.offsetHeight;
    requestAnimationFrame(function () {
      ans.style.transition = 'height 300ms ' + EASE + ', padding-bottom 300ms ' + EASE + ', opacity 150ms ' + EASE;
      ans.style.height = '0px'; ans.style.paddingBottom = '0px'; ans.style.opacity = '0';
    });
    onHeightEnd(ans, function () {
      d.open = false;
      ans.style.transition = ''; ans.style.height = ''; ans.style.overflow = '';
      ans.style.paddingBottom = ''; ans.style.opacity = '';
      d.__anim = false;
    });
  }
  function setupFaq() {
    document.querySelectorAll('.clickable-faq details').forEach(function (d) {
      if (d.__faqWired) return;
      d.__faqWired = true;
      var summary = d.querySelector('summary');
      var ans = d.querySelector('summary + *');
      if (!summary || !ans) return;
      summary.addEventListener('click', function (ev) {
        if (reduce) return; /* native instant toggle */
        ev.preventDefault();
        if (d.__anim) return;
        if (d.open) closeFaq(d, ans); else openFaq(d, ans);
      });
    });
  }

  /* Scene 1 — quality production line (index-motion buildScene1:436-441):
     parts strip translateX(-10% -> 0) over 2.5s, once at 0.3 visibility. */
  function setupScene() {
    var scene = document.querySelector('[data-quality-scene]');
    var parts = document.querySelector('[data-quality-parts]');
    if (!scene || !parts) return;
    if (reduce) { parts.style.transform = 'translateX(0)'; return; }
    if (!('IntersectionObserver' in window)) { parts.style.transform = 'translateX(0)'; return; }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          io.disconnect();
          parts.style.transition = 'transform 2.5s ' + EASE;
          requestAnimationFrame(function () { parts.style.transform = 'translateX(0)'; });
          return;
        }
      }
    }, { threshold: 0.3 });
    io.observe(scene);
  }

  function init() {
    markItems();
    setupReveal();
    setupFaq();
    setupScene();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
